<script>
  import AnimatedTitle from '../components/AnimatedTitle.svelte'
  import AnimatedBullets from '../components/AnimatedBullets.svelte'
  import Diagram from '../charts/ConnectTheDots.svelte'
  import LaptopVideo from '../components/LaptopVideo.svelte'

  let clientWidth;

  $: useMobile = clientWidth < 768

</script>
<section class="part6" bind:clientWidth={clientWidth}>
  <div class="rgrid-md-3-4">
    <div class="col">
      <AnimatedTitle class="large">Connect the dots between linear and digital.</AnimatedTitle>
    </div>
  </div>
  <div class="full-width diagram">
    <Diagram />
  </div>
  <div class="feature feature1 rgrid-md-1-2">
    <div class="text-col">
      <AnimatedTitle size={3} desktopSize={5}>Cross-Screen Planner</AnimatedTitle>
      <AnimatedBullets>
        <li>Our Cross-Screen Planner helps you understand what incremental reach you can achieve relative to your linear TV plan.</li>
        <li>Input your linear TV plan and the parameters of your digital plan, and the output shows incremental and overlapping reach as well as GRP forecasts across devices and formats.</li>
      </AnimatedBullets>
    </div>
    <div class="laptop-col">
      <LaptopVideo animated={true} animParams={{scale: 1.52, xPercent: -7.9, yPercent: -11.4, ease: 'power2.inOut', duration: .3}} animTime={2} poster={`https://res.cloudinary.com/tanka-design/image/upload/c_scale,q_auto/v1616185364/VerizonMediaATV/cross-screen-planner_wbubnm.jpg`}></LaptopVideo>
    </div>
  </div>
  <div class="feature feature2 rgrid-md-1-2">
    <div class="text-col">
      <AnimatedTitle size={3} desktopSize={5}>Unified TV Report</AnimatedTitle>
      <AnimatedBullets>
        <li>Enables you to view reach and frequency across digital and linear spends.</li>
        <li>With the Unified TV Report, you can answer questions like:
          <ul class="level2">
            <li>Which publisher partners provided the most incremental reach to my linear buy?</li>
            <li>What is my combined frequency across digital and linear TV?</li>
          </ul>
        </li>
      </AnimatedBullets>
    </div>
    <div class="laptop-col">
      <LaptopVideo animated={true} animParams={{scale: 1.45, xPercent: -15.8, yPercent: -19, ease: 'power2.inOut', duration: .3}} animTime={2} poster={`https://res.cloudinary.com/tanka-design/image/upload/c_scale,q_auto/v1616185364/VerizonMediaATV/unified-tv-report_jtbmac.jpg`}></LaptopVideo>
    </div>
  </div>
</section>

<style>
  .diagram {
    overflow: hidden;
    margin-top: 3rem;
    margin-bottom: 8rem;
  }
  .diagram :global(svg) {
    position: relative;
    left: 50%;
    transform: translateX(-50%);
  }
  .feature + .feature {
    margin-top: 6rem;
  }
  .feature :global(.laptop) {
    margin-top: 3rem;
  }
  @media(min-width: 768px) {
    .feature1 .laptop-col {
      grid-column: 1;
      grid-row: 1;
    }
    .feature + .feature {
      margin-top: 12rem;
    }
    .feature :global(.laptop) {
      margin-top: 0;
    }
    .feature1 .text-col {
      grid-column: 2;
      grid-row: 1;
    }
  }
</style>